<ng-container *ngIf="transactions$ | async as transactions">
  <div *ngIf="transactions?.length > 0; else noData">
    <ng-container *ngFor="let data of transactions; trackBy: trackByFn">
      <h4 class="split-transaction-list-header">{{ data?.date }}</h4>
      <div class="split-transaction-list">
        <ng-container *ngFor="let item of data.transactions">
          <fgb-split-transaction-item
            [data]="item"
          ></fgb-split-transaction-item>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="loading$ | async; else loadMoreBtn">
      <div class="split-transaction-list-loading">
        <fgbcl-loading [color]="'black'"></fgbcl-loading>
      </div>
    </ng-container>
    <ng-template #loadMoreBtn>
      <div class="btn-container">
        <button
          id="load-more-btn"
          class="primary"
          (click)="loadMore()"
          *ngIf="!isLoadDisabled"
        >
          Load More
        </button>
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-template #noData>
  <ng-container *ngIf="loading$ | async; else placeholder">
    <div class="split-transaction-list-loading">
      <fgbcl-loading [color]="'black'"></fgbcl-loading>
    </div>
  </ng-container>
  <ng-template #placeholder>
    <div class="no-items w-100 text-center border rounded py-4 mt-4 bg-white">
      <div class="svg ms-auto me-auto" fgbAnimateSvg>
        <img [src]="'placeholders/activity.svg' | contentAssetImage" alt="" />
      </div>
      <p class="text-black text-center font-size-14 mt-2 mb-0">
        {{ "transactions.page.placeholder" | translate }}
      </p>
    </div>
  </ng-template>
</ng-template>
